import {EventType, EventKind} from 'services/analytics/const';
import {buildEventCreator, withoutOverrides} from 'services/analytics';

type AppendMoneyEventName = EventKind.AddIncome | EventKind.AddRefill;

export const converter = withoutOverrides;
export function createEvent(name: AppendMoneyEventName): EventFactory<AppendMoneyEventPayload> {
  return buildEventCreator<EventType.Detailed, AppendMoneyEventPayload>({name, converter});
}

export const createAddIncomeEvent = createEvent(EventKind.AddIncome);
export const createAddRefillEvent = createEvent(EventKind.AddRefill);
